<template lang="pug">
SingleLayout(:item="true", :itemlist="true", :showcases="['albums']")
  template(slot="item", v-if="artist")
    Artist(type="full", :key="artistId", :artist="artist")
  template(slot="showcase-albums", v-if="artistAlbums.length")
    Showcase(
      type="albums",
      :title="$l10n('ALBUMS')",
      :url="`/artists/${artistId}/albums`",
      :items="artistAlbums"
    )
  template(slot="showcase-albums", v-if="latestArtists.length")
    .content__showcase
      Showcase(
        type="artists",
        :title="$l10n('SIMILAR_ARTISTS')",
        :url="`/artists/${artistId}/same`",
        :items="latestArtists"
      )
</template>

<script>
import singlePage from "@/mixins/pages/single.mixin";
import PageLoader from "@/services/pageLoader";
import Showcase from "@/components/Showcase/Showcase";
import Artist from "@/components/Artist/Artist";
import ItemList from "@/components/ItemList/ItemList";
import errorHandler from "@/services/errorHandler";

import { mapGetters } from "vuex";
import { ITEMS_IN_SHOWCASE } from "@/constants";

const strategy = async function (route, ctx) {
  try {
    const { artists: latestArtists = [] } = await PageLoader.getLatestArtists({
      limit: ITEMS_IN_SHOWCASE
    });

    ctx.latestArtistsIds = latestArtists.map((artist) => artist.id);
  } catch (error) {
    errorHandler.add(error);
  }

  try {
    const id = PageLoader.getIdFromRoute(route);
    const { artist = {} } = await PageLoader.getArtist({ id });

    ctx.artistId = id;
    route.meta.title = artist.title;
  } catch (error) {
    errorHandler.resolve(error);
  }

  try {
    const { tracks: artistTracks = [] } = await PageLoader.getTracksByArtist({
      id: ctx.artistId
    });

    ctx.artistTracksIds = artistTracks.map((track) => track.id);
  } catch (error) {
    errorHandler.add(error);
  }

  try {
    const { albums: artistAlbums = [] } = await PageLoader.getAlbumsByArtist({
      id: ctx.artistId
    });

    ctx.artistAlbumsIds = artistAlbums.map((album) => album.id);
  } catch (error) {
    errorHandler.add(error);
  }
};

export default {
  name: "ArtistPage",
  mixins: [
    singlePage(strategy, {
      sections: ["latestArtistsIds"]
    })
  ],

  data() {
    return {
      artistId: null,
      artistTracksIds: [],
      artistAlbumsIds: [],
      latestArtistsIds: []
    };
  },
  computed: {
    ...mapGetters({
      artists: "artists/artists",
      albums: "albums/albums",
      tracks: "tracks/tracks"
    }),
    artist() {
      return this.artists[this.artistId];
    },
    artistTracks() {
      return this.artistTracksIds.map((id) => this.tracks[id]);
    },
    latestArtists() {
      return this.latestArtistsIds.map((id) => this.artists[id]);
    },
    artistAlbums() {
      return this.artistAlbumsIds
        .slice(0, ITEMS_IN_SHOWCASE)
        .map((id) => this.albums[id]);
    },
    tracklist() {
      return {
        id: this.artistId,
        tracks: this.artistTracksIds
      };
    }
  },
  components: {
    Artist,
    ItemList,
    Showcase
  }
};
</script>
